import React from 'react';
import '../../Default.css';
import './PhotoGame.css'
import type Person from './photoGameType'
import photoGame_file from "./photoGame.json"
const persons: Person[] = photoGame_file as any;

function PhotoGame() {
    return (
      <>
        <div className="page-title">
          Who I am?
        </div>
        <div className='text'>
            <div className='paragraf'>
                Do you know people below? Do you know what they have in common?
            </div>
        </div>
        {persons.map((person, index) => 
            <div key={index} className="card">

                <div>
                    <img src={person.img.src} alt={person.name} className='photo'/>
                    <div className="overlay">
                        <div className="photo-game-card-second-side">
                            <div className="sec-side-title">{person.name}</div>
                            <div className="sec-side-lifespan">{person.born} - {person.death}</div>
                            <div className="sec-side-desc">{person.desc}</div>
                        </div>
                    </div>
                </div>

                {person.img.copyright &&
                <div className='copyright copyright-tekst'>
                    <a href={person.img.copyright}>CC BY-SA 2.0 , Wikipedia ( link )</a>
                </div>
                }

            </div>
        )}
      </>
    );
}

export default PhotoGame;

// {/* <div className="overlay">
//                     <div className="sec-side">{item.explanation}</div>
//                 </div>
//                 {item.img.copyright !== undefined ? 
//                     <div className='copyright'>
//                         <a href={item.img.copyright}>sorce</a>
//                     </div> : <></>
//                 } */}